import { render, staticRenderFns } from "./InsertVaribleDropdown.vue?vue&type=template&id=f5b00bec&scoped=true"
import script from "./InsertVaribleDropdown.vue?vue&type=script&lang=js"
export * from "./InsertVaribleDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b00bec",
  null
  
)

export default component.exports